module.exports = __webpack_public_path__ + "img/top.b5852063.svg";